import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "remove-count-group",
  "use": "remove-count-group-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"remove-count-group\"><title>un-count group</title><defs><path id=\"remove-count-group_a\" d=\"M6 6h12v12H6z\" /><path id=\"remove-count-group_b\" d=\"M0 0h12v12H0z\" /></defs><g fill=\"none\" fill-rule=\"evenodd\"><g><use fill-opacity=\"0\" fill=\"#FFF\" xlink:href=\"#remove-count-group_a\" /><path stroke=\"#FFF\" stroke-width=\"2\" d=\"M7 7h10v10H7z\" /></g><g><use fill=\"#FFF\" xlink:href=\"#remove-count-group_b\" /><path stroke=\"#FFF\" d=\"M.5.5h11v11H.5z\" /></g><text font-family=\"TamilMN-Bold, Tamil MN\" font-size=\"14\" font-weight=\"bold\" fill=\"#000\" transform=\"translate(0 -2)\"><tspan x=\"2\" y=\"12\">#</tspan></text></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/remove-count-group.svg
// module id = 593
// module chunks = 0